var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLoungeOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99999 22V19H6.99999V22C6.99999 22.5523 6.55227 23 5.99999 23C5.4477 23 4.99999 22.5523 4.99999 22ZM17 22V19H19V22C19 22.5523 18.5523 23 18 23C17.4477 23 17 22.5523 17 22Z",
    fill: "#242424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.0909C2 10.8357 3.01753 9.81818 4.27273 9.81818H5.63636C6.89156 9.81818 7.90909 10.8357 7.90909 12.0909V13.9091H16.0909V12.0909C16.0909 10.8357 17.1084 9.81818 18.3636 9.81818H19.7273C20.9825 9.81818 22 10.8357 22 12.0909V16.1818C22 17.9391 20.5755 19.3636 18.8182 19.3636H5.18182C3.42455 19.3636 2 17.9391 2 16.1818V12.0909Z",
    fill: "#242424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29299 8.31818H5.63636C7.71998 8.31818 9.40909 10.0073 9.40909 12.0909V12.4091H14.5909V12.0909C14.5909 10.0073 16.28 8.31818 18.3636 8.31818H19.7053C19.6596 6.85082 19.5148 5.91823 19.0566 5.17046C18.6818 4.55885 18.1676 4.04462 17.556 3.66982C16.4629 3 14.975 3 11.9991 3C9.0233 3 7.53538 3 6.44234 3.66982C5.83072 4.04462 5.31649 4.55885 4.94169 5.17046C4.48346 5.91823 4.33871 6.85082 4.29299 8.31818Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLoungeOn);
export default __webpack_public_path__ + "static/media/footer-lounge-on.15f8c82bdb76ba7fd31b7a12989d9ffd.svg";
export { ForwardRef as ReactComponent };